import React, { PureComponent } from 'react';
import List from '../standardAttributes/List';

export default class UprightTaskLight extends PureComponent {
  render() {
    const { attributeName, appApi, configuration } = this.props;
    const listOptions = appApi.config.getAttributeAvailableValues(
      attributeName,
      configuration
    );

    return <List {...this.props} options={listOptions} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/UprightTaskLight.js